import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App'
import { FaArrowRightLong } from "react-icons/fa6";
import box from '../../assets/img/box.png'
import policy from '../../assets/img/policy.png'
import money from '../../assets/img/money.png'
import security from '../../assets/img/security.png'
import { useNavigate } from 'react-router-dom';

const HelpPage = () => {

  const { user, setUser } = useContext(UserContext)
  const token = localStorage.getItem('token')
  const navigate = useNavigate()

  return (
    <div className="innerContainer mx-auto flex gap-x-10 py-[104px] md:py-[106px]">
      <div className="w-full">
        <div className="flex flex-col gap-8 h-full justify-between">
          <div className="title text-lg xl:text-xl font-medium">
            <h2>Hjælp</h2>
          </div>
          <div className="relative grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2">
            <div className="w-full shadow-lg cursor-pointer hover:ring-1 hover:ring-emerald-500 transition-[] group h-56" onClick={() => navigate('forsendelse')}>
                <div className="flex flex-col h-full gap-5 p-5 justify-center">
                    <div className="icon h-16 w-auto">
                        <img src={box} className="w-full h-full object-contain select-none" />
                    </div>
                    <div className="text-center select-none">
                        <h2 className="font-semibold text-base xl:text-lg">Forsendelse</h2>
                        <p className="text-sm">Læs mere om hvordan forsendelse fungere</p>
                    </div>
                </div>
            </div>
            <div className="w-full shadow-lg cursor-pointer hover:ring-1 hover:ring-emerald-500 transition-[] group h-56" onClick={() => navigate('betingelser')}>
                <div className="flex flex-col h-full gap-5 p-5 justify-center">
                    <div className="icon h-16 w-auto">
                        <img src={policy} className="w-full h-full object-contain select-none" />
                    </div>
                    <div className="text-center select-none">
                        <h2 className="font-semibold text-base xl:text-lg">Vilkår og betingelser</h2>
                        <p className="text-sm">Læs mere om betingelser for køb og salg på Studiebogen</p>
                    </div>
                </div>
            </div>
            <div className="w-full shadow-lg cursor-pointer hover:ring-1 hover:ring-emerald-500 transition-[] group h-56" onClick={() => navigate('udbetaling')}>
                <div className="flex flex-col h-full gap-5 p-5 justify-center">
                    <div className="icon h-16 w-auto">
                        <img src={money} className="w-full h-full object-contain select-none" />
                    </div>
                    <div className="text-center select-none">
                        <h2 className="font-semibold text-base xl:text-lg">Udbetaling</h2>
                        <p className="text-sm">Læs mere om hvordan du udbetaler penge fra din saldo</p>
                    </div>
                </div>
            </div>
            <div className="w-full shadow-lg cursor-pointer hover:ring-1 hover:ring-emerald-500 transition-[] group h-56" onClick={() => navigate('sikkerhed')}>
                <div className="flex flex-col h-full gap-5 p-5 justify-center">
                    <div className="icon h-16 w-auto">
                        <img src={security} className="w-full h-full object-contain select-none" />
                    </div>
                    <div className="text-center select-none">
                        <h2 className="font-semibold text-base xl:text-lg">Sikkerhed</h2>
                        <p className="text-sm">Læs mere om sikker handel på Studiebogen</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HelpPage